// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Iji","cls2":"ExportFormatModal-cls2_UEh ExportFormatModal-cls1_Iji"};